import { render } from "./Attachments.vue?vue&type=template&id=4b92a9f2&scoped=true"
import script from "./Attachments.vue?vue&type=script&lang=js"
export * from "./Attachments.vue?vue&type=script&lang=js"

import "./Attachments.vue?vue&type=style&index=0&id=4b92a9f2&scoped=true&lang=scss"

import exportComponent from "/var/www/driveapp2.experimental.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b92a9f2"]])

export default __exports__